// 查看页面和编辑页面公用的参数和方法
import common from '@/config'
import { config } from '@/option/config'
import container from '@/page/group/container'
import mapBorder from "@/assets/100000.json";
import mapBorderFull from "@/assets/100000_full.json";
import mapBorderFullCity from "@/assets/100000_full_city.json";
import { cloneConfig } from '@/schema/legacy-adapter'

export default {
  components: {
    container
  },
  provide () {
    return {
      main: this,
      contain: this
    };
  },
  data () {
    return {
      DIC: {
        MAP: []
      },
      contentWidth: '',
      config: cloneConfig(config),
      projectRecord: null,
      projectVersionStatus: null,
      templateRecord: null,
      templateSaveBlocked: '',
      pageProject: { version: 1, homePageId: '', pages: [] },
      activePageId: '',
      editorViewport: { zoom: 100, panX: 0, panY: 0 },
      obj: {},
      id: '',
      visual: {},
      nav: [],
      common: common,
      active: [],
      overactive: '',
    }
  },
  computed: {
    isSharedView () { return this.$route.name === 'screen-share' },
    isTemplateEditing () { return ['component-resource-edit', 'template-component-edit', 'template-page-edit', 'template-project-edit'].includes(this.$route.name) },
    isComponentResourceEditing () { return this.$route.name === 'component-resource-edit' },
    isComponentTemplateEditing () { return ['component-resource-edit', 'template-component-edit'].includes(this.$route.name) },
    isTemplatePreview () { return ['template-page-preview', 'template-project-preview'].includes(this.$route.name) },
    isPreview () {
      return this.isSharedView || this.isTemplatePreview || (this.$route.name === 'view' && Boolean(this.$route.query.preview))
    },
    list () {
      let result = [];
      //循环处理数据
      const detail = (item) => {
        if (item.children) {
          item.children.forEach(ele => {
            detail(ele);
          })
        } else {
          result.push(item)
        }
      }
      this.nav.forEach(ele => {
        detail(ele);
      })
      return result
    }
  },
  created () {
    this.initDic();
  },
  methods: {
    //初始化字典
    // initDic () {
    //   getList({
    //     current: 1,
    //     size: 100,
    //   }).then(res => {
    //     const data = res.data.data;
    //     this.DIC.MAP = data.records.map(ele => {
    //       return {
    //         label: ele.name,
    //         value: this.url + '/map/data?id=' + ele.id
    //       }
    //     });
    //   })
    // },
    initDic () {

      this.DIC.MAP = [
        {
          label: "中国",
          value: mapBorder
        },
        {
          label: "中国-省",
          value: mapBorderFull
        },
        {
          label: "中国-省-市",
          value: mapBorderFullCity
        }
      ]
      // getAllArea().then(res => {
      //   let data = res.data
      //   console.log(data)
      //        this.DIC.MAP = data.result.map(ele => {
      //     return {
      //       label: ele.fullName,
      //       value: {
      //         type: "FeatureCollection",
      //         features: ele.geoJson ? ele.geoJson.features:'',
      //       }
      //     }
      //   });
      //   console.log(this.DIC.MAP)
      // })
      // this.DIC.MAP = [
      //   {
      //     "label": "建筑A",
      //     "value": {
      //       "type": "FeatureCollection",
      //       "features": [
      //         {
      //           "type": "Feature",
      //           "geometry": {
      //             "type": "Polygon",
      //             "coordinates": [
      //               [
      //                 [120.15, 30.28],
      //                 [120.16, 30.28],
      //                 [120.16, 30.29],
      //                 [120.15, 30.29],
      //                 [120.15, 30.28]
      //               ]
      //             ]
      //           },
      //           "properties": {
      //             "id": "001",
      //             "name": "建筑A",
      //             "parentId": "root",
      //             "objectType": "building"
      //           }
      //         }
      //       ]
      //     }
      //   },
      //   {
      //     "label": "建筑B",
      //     "value": {
      //       "type": "FeatureCollection",
      //       "features": [
      //         {
      //           "type": "Feature",
      //           "geometry": {
      //             "type": "Point",
      //             "coordinates": [120.18, 30.27]
      //           },
      //           "properties": {
      //             "id": "002",
      //             "name": "建筑B",
      //             "parentId": "root",
      //             "objectType": "building"
      //           }
      //         }
      //       ]
      //     }
      //   }
      // ]
      
      // getList1({
      //   filter: {
      //     pageSize: 1000,
      //   },
      // }).then(res => {
      //   const data = res.data.result;
      //   // data.features.forEach((item) => {
      //   //   let x = item.properties.parentId
      //   //   let y = data.features.filter(i => {
      //   //     return i.properties.parentId == x
      //   //   })
      //   //   console.log(y)
      //   // })
      //   // console.log(data.features)
      //   this.DIC.MAP = data.features.map(ele => {
      //     return {
      //       label: ele.properties.name,
      //       value: {
      //         type: "FeatureCollection",
      //         features: [{type: "Feature",geometry: ele.geometry,properties: ele.properties}],
      //       }
      //     }
      //   });
      // })
    },
    findnav (id, type) {
      //循环处理数据
      let obj = undefined;
      let count = 0;
      let parent = undefined;
      let pcount = 0;
      let len = 0;
      const detail = (item, list, i, number = 0) => {
        if (!item.children || type) {
          if (id === item.index) {
            obj = item;
            len = Array.isArray(list) ? list.length - 1 : list.children.length - 1;
            parent = list;
            pcount = number;
            count = i;
          }
        }
        if (item.children) {
          item.children.forEach((ele, index) => {
            detail(ele, item, index, number + 1);
          })
        }
      }
      this.nav.forEach((ele, index) => {
        detail(ele, this.nav, index);
      })
      return {
        obj,
        count,
        len,
        pcount,
        parent
      }
    },
    findlist (index) {
      return this.list.find(ele => ele.index == index) || {}
    },
    handleInitActive () {
      this.active = []
    },
    handleMouseDown () {
      this.handleInitActive();
    },
  }
}
